document.querySelectorAll('.read-more-btn').forEach( (btn) => {
	btn.addEventListener('click', function () {
		let txtMore = 'Read More'
		let txtLess = 'Read Less'
		let moreContent = this.parentElement.querySelector('.read-more-content');
		this.classList.toggle('active');
		if (this.classList.contains('active')) {
			this.innerHTML = txtLess;
			moreContent.style.display = 'block';
		} else {
			this.innerHTML = txtMore;
			moreContent.style.display = 'none';
		}
	});
});
// ── EVJ: Hide Judge.me badges with 0 reviews or rating < 4 ──────────────────
(function () {
  function shouldHide(badge) {
    var reviews = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
    var rating  = parseFloat(badge.getAttribute('data-average-rating') || '0');
    return reviews === 0 || rating < 4;
  }

  function hideBadge(badge) {
    badge.style.setProperty('display', 'none', 'important');
    var wrapper = badge.closest('.jdgm-widget.jdgm-preview-badge');
    if (wrapper) wrapper.style.setProperty('display', 'none', 'important');
  }

  function filterBadges() {
    document.querySelectorAll('.jdgm-prev-badge').forEach(function (badge) {
      if (shouldHide(badge)) hideBadge(badge);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'style') {
        var el = m.target;
        var inner = el.querySelector('.jdgm-prev-badge');
        if (inner && shouldHide(inner)) hideBadge(inner);
        if (el.classList.contains('jdgm-prev-badge') && shouldHide(el)) hideBadge(el);
      }
    });
  });

  function startObserver() {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      subtree: true,
    });
    filterBadges();
  }

  document.addEventListener('jdgm:all:done', filterBadges);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();


// ── EVJ: mobile product-card swipe (packshot ↔ lifestyle) ───────────────────
// Nested rails (Best Sellers etc.) use Swiper. Pause the parent rail while
// the finger is on a product photo so the photo swipes, not the whole panel.
(function () {
  var SWIPE_PX = 10;
  var activeLink = null;

  function isSwipeLink(el) {
    return el && el.classList && el.classList.contains('product-item__image-link--swipe');
  }

  function swipeLinkFromEvent(e) {
    return e.target && e.target.closest && e.target.closest('.product-item__image-link--swipe');
  }

  function findSwiper(link) {
    var el = link && link.closest && link.closest('.swiper');
    return el && el.swiper ? el.swiper : null;
  }

  function lockRail(link) {
    var swiper = findSwiper(link);
    if (!swiper) return;
    link._evjSwiper = swiper;
    link._evjPrevAllow = swiper.allowTouchMove;
    swiper.allowTouchMove = false;
  }

  function unlockRail(link) {
    if (!link || !link._evjSwiper) return;
    link._evjSwiper.allowTouchMove = link._evjPrevAllow !== false;
    link._evjSwiper = null;
  }

  function updateDots(link) {
    var media = link.closest('.product-item__media');
    if (!media) return;
    var dots = media.querySelectorAll('.product-item__dot');
    if (!dots.length || !link.clientWidth) return;
    var i = Math.round(link.scrollLeft / link.clientWidth);
    if (i < 0) i = 0;
    if (i > dots.length - 1) i = dots.length - 1;
    dots.forEach(function (dot, idx) {
      dot.classList.toggle('is-active', idx === i);
    });
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      var link = swipeLinkFromEvent(e);
      if (!link || !e.touches || !e.touches[0]) return;
      activeLink = link;
      link._evjX = e.touches[0].clientX;
      link._evjY = e.touches[0].clientY;
      link._evjMoved = false;
      lockRail(link);
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      var link = swipeLinkFromEvent(e) || activeLink;
      if (!link || !e.touches || !e.touches[0] || link._evjX == null) return;
      var dx = e.touches[0].clientX - link._evjX;
      var dy = e.touches[0].clientY - link._evjY;
      if (Math.abs(dx) > SWIPE_PX && Math.abs(dx) > Math.abs(dy)) {
        link._evjMoved = true;
      }
    },
    { capture: true, passive: true }
  );

  function endTouch() {
    if (!activeLink) return;
    unlockRail(activeLink);
    activeLink = null;
  }

  document.addEventListener('touchend', endTouch, { capture: true, passive: true });
  document.addEventListener('touchcancel', endTouch, { capture: true, passive: true });

  document.addEventListener(
    'click',
    function (e) {
      var link = swipeLinkFromEvent(e);
      if (!link) return;
      if (link._evjMoved) {
        e.preventDefault();
        e.stopPropagation();
        link._evjMoved = false;
      }
    },
    true
  );

  document.addEventListener(
    'scroll',
    function (e) {
      if (isSwipeLink(e.target)) updateDots(e.target);
    },
    true
  );
})();
